import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Home extends Component {
    render() {
        return (
            <section>
                <div className="" id="showcase">  
                    <div className="showcase-us">    
                    <h3>Welcome to</h3>  
                    <h3>Fredrick Ovie Agbaje Foundation</h3>
                    <p>Our mission is to extend a helping hand</p>   
                    <p>to young rural dwellers via track and field</p>                    
                    <Link to='/about' className="button-about" title="About FA-Foundation"> 
                    ...More about us
                    </Link>   
                    </div>
                </div>
            </section>
        )
    }
}
